"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariableFromState = exports.getStateKeys = exports.hasMissingVariableName = exports.getStrippedVariableNames = exports.getVariableNames = exports.stripSymbols = void 0;
const types_1 = require("./types");
// Remove the first 2 and the last characters
// Intended to remove '${' and '}'. E.g. '${name}' -> 'name'
function stripSymbols(text) {
    if (text.indexOf('${') === 0)
        return text.substring(2, text.length - 1);
    return text.substring(1, text.length - 1);
}
exports.stripSymbols = stripSymbols;
// Returns an array of variable names after optionally transforming each value.
function getVariableNames(tokens, transformValue, tokenType = types_1.TokenType.VARIABLE) {
    return tokens
        .filter((t) => t.type === tokenType)
        .map((t) => transformValue ? transformValue(t.value) : t.value);
}
exports.getVariableNames = getVariableNames;
// Returns an array of variable names without any wrapping symbols.
function getStrippedVariableNames(tokens) {
    return getVariableNames(tokens, stripSymbols, types_1.TokenType.PLACEHOLDER);
}
exports.getStrippedVariableNames = getStrippedVariableNames;
// Returns true if there's a variable name that doesn't appear
// in the provided list of state keys.
function hasMissingVariableName(variableNames, stateKeys) {
    return variableNames.some((v) => !stateKeys.includes(v));
}
exports.hasMissingVariableName = hasMissingVariableName;
function getStateKeys(state = {}) {
    return Object.entries(state).reduce((soFar, [field, value]) => {
        const nestedFields = Object.keys(typeof value === "object" ? value : {});
        if (nestedFields.length > 0) {
            // @ts-ignore
            for (const key of getStateKeys(value))
                soFar.push(`${field}.${key}`);
        }
        // @ts-ignore
        soFar.push(field);
        return soFar;
    }, []);
}
exports.getStateKeys = getStateKeys;
function getVariableFromState(variableName, state) {
    let value = state;
    for (const field of variableName.split('.')) {
        value = value === null || value === void 0 ? void 0 : value[field];
    }
    return value;
}
exports.getVariableFromState = getVariableFromState;
